var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    {
      staticClass:
        "mt-40 cursor-pointer inline-block uppercase text-18 font-extraBold text-white border border-red rounded-8 bg-red py-[20px] px-[22px] hover:bg-transparent hover:text-red transition-colors",
      on: {
        click: function($event) {
          $event.preventDefault()
          return _vm.openCalendly.apply(null, arguments)
        }
      }
    },
    [_vm._v("\n    " + _vm._s(_vm.title) + "\n")]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }